var $ade0309b59968ca5$exports = {};
$ade0309b59968ca5$exports = {
    "replaceMessage": `Datei zum Ersetzen ablegen`
};


export {$ade0309b59968ca5$exports as default};
//# sourceMappingURL=de-DE.mjs.map
